/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgPaginationArrowLeft: React.FC<React.SVGAttributes<
    SVGElement
>> = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M15 18l-6-6 6-6"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
